import React from "react"

import {FieldGraphTickLabelViewProps} from "../../../render/graph-tick-label"
import UserIcon from "../../../../gd-components/icons/user/user"
import Field_GraphTickLabelView from "../../../proto/render/graph-tick-label"

const LABEL_SHOW_THRESHOLD = 100

const debug = false
// const debug = "FieldUser_GraphTickLabelView"

export default function FieldUser_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    let option = props.field._getOption(props.field.getViewValue(props.model))
    if (!option) { // if no value then set special field value
        option = {
            label   : props.field.noValueOptionLabel
        }
    }

    debug && console.log(debug, 'render', option, props)

    let showLabel = props.params.availableWidth > LABEL_SHOW_THRESHOLD

    const iconClasses = Classes('flex-no-shrink', {
        'm-r-5': showLabel
    })

    return (
        <Field_GraphTickLabelView {...props} hintName={option.label}>
            <UserIcon className={iconClasses} size='22' userId={option.value ? option.value : 'none'}/>
            {showLabel && <div className="ui5-txt-default-small txt-truncate">{option.label}</div>}
        </Field_GraphTickLabelView>
    )
}